"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isInStandaloneMode = exports.isIOSEdge = exports.isIOSChrome = exports.isIOS = void 0;

var isInStandaloneMode = function isInStandaloneMode() {
  return "standalone" in window.navigator && window.navigator.standalone;
};

exports.isInStandaloneMode = isInStandaloneMode;

var isIOS = function isIOS() {
  var userAgent = window.navigator.userAgent.toLowerCase();
  return /iphone|ipad|ipod/.test(userAgent);
};

exports.isIOS = isIOS;

var isIOSChrome = function isIOSChrome() {
  return window.navigator.userAgent.indexOf("CriOS") !== -1;
};

exports.isIOSChrome = isIOSChrome;

var isIOSEdge = function isIOSEdge() {
  return window.navigator.userAgent.indexOf("EdgiOS") !== -1;
};

exports.isIOSEdge = isIOSEdge;